import auth0 from 'auth0-js'
import EventEmitter from 'eventemitter3'
import router from '../router'
import User from '../models/User'

class AuthService {
  public authNotifier = new EventEmitter()
  private user: User = this.loadUser()
  private authenticated = this.isAuthenticated()

  private auth0 = new auth0.WebAuth({
    domain: process.env.VUE_APP_AUTH0_DOMAIN,
    clientID: process.env.VUE_APP_AUTH0_CLIENT_ID,
    redirectUri: process.env.VUE_APP_AUTH0_REDIRECT_URI,
    responseType: 'token id_token',
    scope: 'openid'
  })

  public login () {
    this.auth0.authorize()
  }

  // ...
  public handleAuthentication () {
    this.auth0.parseHash((err, authResult) => {
      if (authResult && authResult.accessToken && authResult.idToken) {
        this.setSession(authResult)
        router.replace('dashboard')
      } else if (err) {
        router.replace('error')
        console.log(err)
      }
    })
  }

  public setSession (authResult: any) {
    this.user = new User()
    this.user.accessToken = authResult.accessToken,
    this.user.idToken = authResult.idToken,
    this.user.expiresAt = authResult.expiresIn * 1000 + new Date().getTime()

    this.authNotifier.emit('authChange', { authenticated: true })

    localStorage.setItem('loggedInUser', this.user.ToJSON())
  }

  public renewSession () {
    this.auth0.checkSession({}, (err, authResult) => {
      if (authResult && authResult.accessToken && authResult.idToken) {
        this.setSession(authResult)
      } else if (err) {
        this.logout()
        console.log(err)
      }
    })
  }

  public logout () {
    // Clear access token and ID token from local storage
    this.user.accessToken = null
    this.user.idToken = null
    this.user.expiresAt = null
    this.user.userProfile = null // TODO: What is this? It's not even used anywhere..

    // this.authNotifier.emit('authChange', false)
    this.authNotifier.emit('authChange', { authenticated: false })

    localStorage.removeItem('loggedInUser')
    // localStorage.setItem('loggedInUser', this.user.ToJSON())

    // navigate to the home route
    router.replace('/')
  }

  /*public getAuthenticatedFlag () {
    return localStorage.getItem('loggedInUser')
  }*/

  public isAuthenticated () {
    return this.user && this.user.IsAuthenticated()
    // return new Date().getTime() < this.user.expiresAt && this.getAuthenticatedFlag() === 'true'
  }

  private loadUser (): User {
    const userJSON = localStorage.getItem('loggedInUser')
    if (userJSON && userJSON.length > 0) {
      try {
        const user: User = JSON.parse(userJSON) as User
        this.authNotifier.emit('authChange', { authenticated: this.isAuthenticated() })
        return Object.assign(new User(), user)
      } catch (err) {
        console.log(err)
      }
    }
    return new User()
  }
}

export default AuthService
